import { createContext } from 'react';

// Simple adapter interface that mimics the Socket.io methods we use
export interface WebSocketAdapter {
  // Core emit methods
  emit: (event: string, data: any) => void;
  on: (event: string, callback: (data: any) => void) => void;
  off: (event: string, callback?: (data: any) => void) => void;
  
  // Method to notify all listeners of a specific event
  notifyListeners: (event: string, data: any) => void;
  
  // Helper method to send game messages in consistent format
  sendGameMessage: (type: string, data: any) => void;
  
  // Additional Socket.io compatibility methods for broader support
  once?: (event: string, callback: (data: any) => void) => void;
  connect?: () => void;
  disconnect?: () => void;
  removeListener?: (event: string, callback?: Function) => void;
  removeAllListeners?: (event?: string) => void;
  
  // Socket.io-like properties
  connected?: boolean;
  disconnected?: boolean;
  id?: string;
}

// Create a WebSocket-compatible context
const SocketContext = createContext<WebSocketAdapter | null>(null);

export default SocketContext; 